<template>
  <path
    d="M19.23 15.2603L16.69 14.9703C16.08 14.9003 15.48 15.1103 15.05 15.5403L13.21 17.3803C10.38 15.9403 8.06004 13.6303 6.62004 10.7903L8.47004 8.94025C8.90004 8.51025 9.11004 7.91025 9.04004 7.30025L8.75004 4.78025C8.63004 3.77025 7.78004 3.01025 6.76004 3.01025H5.03004C3.90004 3.01025 2.96004 3.95025 3.03004 5.08025C3.56004 13.6203 10.39 20.4403 18.92 20.9703C20.05 21.0403 20.99 20.1003 20.99 18.9703V17.2403C21 16.2303 20.24 15.3803 19.23 15.2603Z"
  />
</template>
